// Carousel - keep existing code
const carousel = document.querySelector(".product-carousel");
if (carousel) {
  const track = carousel.querySelector(".product-carousel-track");
  const images = Array.from(track.querySelectorAll(".product-image"));
  const indicators = Array.from(
    carousel.querySelectorAll(".carousel-indicator")
  );
  let current = 0;
  let timer = null;

  // Nothing to swipe or advance to with a single image. Without this the track
  // still dragged under the finger and snapped back — a carousel that looks
  // broken — and a 5s timer ran to re-show the same image.
  const canSwipe = images.length > 1;

  function goTo(index) {
    if (index < 0) index = images.length - 1;
    if (index >= images.length) index = 0;
    track.style.transform = `translateX(-${index * 100}%)`;
    indicators.forEach((el, i) => el.classList.toggle("active", i === index));
    current = index;
  }

  function next() {
    goTo(current + 1);
  }

  function prev() {
    goTo(current - 1);
  }

  function startAuto() {
    if (!canSwipe) return;
    stopAuto();
    timer = setInterval(next, 5000);
  }

  function stopAuto() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  indicators.forEach((btn, i) => {
    btn.addEventListener("click", () => {
      goTo(i);
      startAuto();
    });
  });

  carousel.addEventListener("mouseenter", stopAuto);
  carousel.addEventListener("mouseleave", startAuto);

  // Touch/swipe support (improved swipe with velocity + threshold)
  let startX = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;
  let animationID = 0;
  let startTime = 0;
  let isDragging = false;

  if (canSwipe) {
    track.addEventListener("touchstart", touchStart);
    track.addEventListener("touchmove", touchMove);
    track.addEventListener("touchend", touchEnd);
  }

  function touchStart(e) {
    if (e.touches.length !== 1) return;
    startX = e.touches[0].clientX;
    prevTranslate = -current * track.clientWidth;
    startTime = Date.now();
    isDragging = true;
    cancelAnimationFrame(animationID);
    track.style.transition = "none";
    stopAuto();
  }

  function touchMove(e) {
    if (!isDragging) return;
    const currentX = e.touches[0].clientX;
    const deltaX = currentX - startX;
    currentTranslate = prevTranslate + deltaX;
    setSliderPosition();
  }

  function touchEnd(e) {
    if (!isDragging) return;
    isDragging = false;

    const movedBy = currentTranslate - prevTranslate;
    const duration = Date.now() - startTime;
    const velocity = Math.abs(movedBy) / duration;

    // If swipe was significant enough
    if (movedBy < -50 || (velocity > 0.5 && movedBy < -10)) {
      next();
    } else if (movedBy > 50 || (velocity > 0.5 && movedBy > 10)) {
      prev();
    } else {
      goTo(current); // Snap back
    }

    startAuto();
  }

  function setSliderPosition() {
    track.style.transform = `translateX(${currentTranslate}px)`;
  }

  // Image zoom
  const zoomOverlay = document.querySelector(".product-zoom-overlay");
  const zoomImage = document.querySelector(".product-zoom-image");
  const zoomClose = document.querySelector(".product-zoom-close");

  images.forEach((img) => {
    img.addEventListener("click", function () {
      zoomImage.src = img.src;
      zoomOverlay.classList.add("active");
      zoomOverlay.setAttribute("aria-hidden", "false");
      zoomOverlay.focus();
      openModal();
      stopAuto();
    });
  });

  function closeZoom() {
    zoomOverlay.classList.remove("active");
    zoomOverlay.setAttribute("aria-hidden", "true");
    zoomImage.src = "";
    closeModal();
    startAuto();
  }

  zoomOverlay.addEventListener("click", function (e) {
    if (e.target === zoomOverlay || e.target === zoomClose) {
      closeZoom();
    }
  });
  zoomClose.addEventListener("click", closeZoom);
  document.addEventListener("keydown", function (e) {
    if (
      zoomOverlay.classList.contains("active") &&
      (e.key === "Escape" || e.key === "Esc")
    ) {
      closeZoom();
    }
  });

  goTo(0);
  startAuto();
}

// === Product class ===
class Product {
  constructor(productSectionEl) {
    this.productSectionEl = productSectionEl;
    this.productHandle = productSectionEl.dataset.productHandle;
    this.selectedVariantId = parseInt(
      productSectionEl.dataset.selectedVariantId,
      10
    );

    this.stepperWrapper = productSectionEl.querySelector(
      ".product-quantity-stepper-wrapper"
    );
    this.stepper = productSectionEl.querySelector(".product-quantity-stepper");
    this.qtyDisplay = productSectionEl.querySelector(
      ".product-quantity-stepper .quantity-stepper__quantity"
    );
    this.conversionButtonWrapper = productSectionEl.querySelector(
      ".product-conversion-button-wrapper"
    );
    this.conversionButton = productSectionEl.querySelector(
      ".product-add-to-cart"
    );
    this.soldOutButtonWrapper = productSectionEl.querySelector(
      ".product-sold-out-button-wrapper"
    );

    this.bindEvents();
    this.updateUI();

    document.addEventListener("cart:updated", (e) => {
      const { variantId } = e.detail || {};
      if (variantId === this.selectedVariantId) {
        this.updateUI();
      }
    });
  }

  bindEvents() {
    // Variant pills click → update variant selection without page reload
    document.querySelectorAll(".variant-pill").forEach((pill) => {
      pill.addEventListener("click", (e) => {
        e.preventDefault();
        const variantId = parseInt(pill.dataset.variantId, 10);
        if (variantId !== this.selectedVariantId) {
          this.selectVariant(variantId);
        }
      });
    });

    // Add to Cart button
    if (this.conversionButton) {
      this.conversionButton.addEventListener("click", () => {
        // Optimistic add (instant, debounced sync) — no blocking spinner
        QuantityManager.step(this.selectedVariantId, 1);
      });
    }

    // Quantity Stepper buttons - handled by global listener in theme.js
  }

  selectVariant(variantId) {
    // Update selected variant ID
    this.selectedVariantId = variantId;

    // Update URL without page reload
    const url = new URL(window.location.href);
    url.searchParams.set("variant", variantId);
    window.history.replaceState({}, "", url.toString());

    // Update product section data attribute
    this.productSectionEl.dataset.selectedVariantId = variantId;
    this.stepper.dataset.variantId = variantId;

    // Update variant pill active states
    document.querySelectorAll(".variant-pill").forEach((pill) => {
      const pillVariantId = parseInt(pill.dataset.variantId, 10);
      const on = pillVariantId === variantId;
      pill.classList.toggle("variant-pill--active", on);
      pill.setAttribute("aria-pressed", on ? "true" : "false");
    });

    // Update product price
    const variant = this.getVariantData(variantId);
    if (variant) {
      this.updateProductPrice(variant);
    }

    // Update product images if available
    this.updateProductImages(variantId);

    // Update UI for cart state
    this.updateUI();

    // Emit event to update the product info
    document.dispatchEvent(
      new CustomEvent("variant:change", {
        detail: {
          variant: variant,
          variantId: variantId,
        },
      })
    );
  }

  getVariantData(variantId) {
    // Get variant data from the global productVariants
    if (window.productVariants) {
      return window.productVariants.find((variant) => variant.id === variantId);
    }
    return null;
  }

  updateProductPrice(variant) {
    const priceElement = this.productSectionEl.querySelector(
      ".product-price .price"
    );
    const comparePriceElement = this.productSectionEl.querySelector(
      ".product-price .compare-price"
    );

    // The mobile sticky bar repeats the unit and price, so it has to track the
    // selection too — it's the only copy visible once the page is scrolled.
    const stickyPrice = this.productSectionEl.querySelector("[data-sticky-price]");
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    const stickyUnit = this.productSectionEl.querySelector("[data-sticky-unit]");
    if (stickyUnit) {
      stickyUnit.textContent =
        variant.title === "Default Title" ? "" : variant.title;
    }

    if (priceElement) {
      priceElement.textContent = formatMoney(variant.price);
    }

    if (comparePriceElement) {
      if (variant.compare_at_price > variant.price) {
        comparePriceElement.textContent = formatMoney(variant.compare_at_price);
        comparePriceElement.style.display = "inline";
      } else {
        comparePriceElement.style.display = "none";
      }
    }
  }

  // Use the global formatMoney function from theme.js

  updateProductImages(variantId) {
    // This would need to be implemented based on your image structure
    // For now, we'll leave this as a placeholder
    // You might want to update the carousel images based on variant
  }

  updateUI() {
    // Use the optimistic quantity so the product page reacts instantly too
    const cartQty = QuantityManager.currentQty(this.selectedVariantId);

    // Get variant data to check availability
    const variant = this.getVariantData(this.selectedVariantId);
    // purchasableHere (theme.js) reads the resolved answer Liquid published. This
    // recompute runs in the constructor, so deriving it from Shopify's shop-wide
    // variant.available re-enabled the add button before anyone saw it disabled.
    const isAvailable = variant
      ? window.purchasableHere
        ? window.purchasableHere(this.productSectionEl, this.selectedVariantId, variant.available)
        : variant.available
      : false;

    if (cartQty > 0) {
      // Item is in cart - show stepper
      if (this.stepperWrapper) this.stepperWrapper.classList.remove("hidden");
      if (this.qtyDisplay) animateStepperQuantity(this.qtyDisplay, cartQty);
      if (this.conversionButtonWrapper)
        this.conversionButtonWrapper.classList.add("hidden");
      if (this.soldOutButtonWrapper)
        this.soldOutButtonWrapper.classList.add("hidden");
    } else if (isAvailable) {
      // Item is not in cart but available - show add to cart button
      if (this.stepperWrapper) this.stepperWrapper.classList.add("hidden");
      if (this.conversionButtonWrapper)
        this.conversionButtonWrapper.classList.remove("hidden");
      if (this.soldOutButtonWrapper)
        this.soldOutButtonWrapper.classList.add("hidden");
    } else {
      // Item is not available - show sold out button
      if (this.stepperWrapper) this.stepperWrapper.classList.add("hidden");
      if (this.conversionButtonWrapper)
        this.conversionButtonWrapper.classList.add("hidden");
      if (this.soldOutButtonWrapper)
        this.soldOutButtonWrapper.classList.remove("hidden");
    }
  }
}

// === Main init ===
document.addEventListener("DOMContentLoaded", () => {
  const productSection = document.querySelector(".product-wrapper");
  if (productSection) {
    new Product(productSection);
  }
});
